import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TellentAssistantBrandMarkComponent } from '@core/tellent-assistant-ui';

import { TellentAssistantMobileService } from '../tellent-assistant-mobile.service';

@Component({
  selector: 'tellent-assistant-mobile-trigger',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TellentAssistantBrandMarkComponent],
  template: `
    <button class="trigger" type="button" (click)="service.toggle()">
      <tellent-assistant-brand-mark [size]="28" />
    </button>
  `,
  styleUrl: './tellent-assistant-mobile-trigger.component.less',
})
export class TellentAssistantMobileTriggerComponent {
  protected readonly service = inject(TellentAssistantMobileService);
}
